module.exports = __webpack_public_path__ + "static/media/29ADMSPC18.ebf7b163.jpg";